import React, { useMemo } from "react";
import Dropdown from "../../common/dropDown";
import { FORMULA_OPERATORS } from "./esourceFieldTypes";

/**
 * Structured formula editor (no eval) for calculated fields.
 */
export default function ESourceFormulaBuilder({
  formula,
  fields = [],
  onChange,
}) {
  const fieldOptions = useMemo(
    () =>
      (fields || []).map((f) => ({
        value: f.id,
        label: f.label || f.fieldName || f.id,
      })),
    [fields],
  );

  const operator =
    FORMULA_OPERATORS.find((o) => o.value === formula?.operator) ||
    FORMULA_OPERATORS[0];

  const isAggregate = ["sum", "min", "max", "average"].includes(
    operator.value,
  );

  const leftSel =
    fieldOptions.find((o) => o.value === formula?.left?.fieldId) || null;
  const rightSel =
    fieldOptions.find((o) => o.value === formula?.right?.fieldId) || null;

  const selectedMulti = useMemo(() => {
    const ids = Array.isArray(formula?.fieldIds) ? formula.fieldIds : [];
    return fieldOptions.filter((o) => ids.includes(o.value));
  }, [formula?.fieldIds, fieldOptions]);

  return (
    <div className="esource-formula-builder">
      <div className="esource-builder-field">
        <label className="esource-builder-field__label">Operator</label>
        <Dropdown
          options={FORMULA_OPERATORS}
          isMulti={false}
          showSearch={false}
          size="sm"
          selected={operator}
          onSelect={(opt) => {
            const op = opt?.value || "add";
            if (["sum", "min", "max", "average"].includes(op)) {
              onChange?.({
                operator: op,
                fieldIds: Array.isArray(formula?.fieldIds)
                  ? formula.fieldIds
                  : [],
              });
            } else {
              onChange?.({
                operator: op,
                left: { fieldId: formula?.left?.fieldId || "" },
                right: { fieldId: formula?.right?.fieldId || "" },
              });
            }
          }}
        />
      </div>

      {isAggregate ? (
        <div className="esource-builder-field">
          <label className="esource-builder-field__label">
            Numeric fields
          </label>
          <Dropdown
            options={fieldOptions}
            isMulti
            showSearch
            size="sm"
            selected={selectedMulti}
            onSelect={(opts) =>
              onChange?.({
                operator: operator.value,
                fieldIds: Array.isArray(opts)
                  ? opts.map((o) => o.value)
                  : [],
              })
            }
          />
          {!fieldOptions.length ? (
            <span className="form-text">
              Add integer or number fields first.
            </span>
          ) : null}
        </div>
      ) : (
        <>
          <div className="esource-builder-field">
            <label className="esource-builder-field__label">Left field</label>
            <Dropdown
              options={fieldOptions}
              isMulti={false}
              showSearch
              size="sm"
              selected={leftSel}
              onSelect={(opt) =>
                onChange?.({
                  operator: operator.value,
                  left: { fieldId: opt?.value || "" },
                  right: { fieldId: formula?.right?.fieldId || "" },
                })
              }
            />
          </div>
          <div className="esource-builder-field">
            <label className="esource-builder-field__label">Right field</label>
            <Dropdown
              options={fieldOptions}
              isMulti={false}
              showSearch
              size="sm"
              selected={rightSel}
              onSelect={(opt) =>
                onChange?.({
                  operator: operator.value,
                  left: { fieldId: formula?.left?.fieldId || "" },
                  right: { fieldId: opt?.value || "" },
                })
              }
            />
          </div>
        </>
      )}
    </div>
  );
}
